import apiClient from '../client';

const BASE_URL = '/wholesale/document-settings';

/**
 * Get active wholesale document configuration
 */
export const getDocumentSettings = async () => {
  const response = await apiClient.get(BASE_URL);
  return response.data;
};

/**
 * Get wholesale document configuration by ID
 */
export const getDocumentSettingsById = async (id) => {
  const response = await apiClient.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Update wholesale document configuration
 */
export const updateDocumentSettings = async (id, settings) => {
  const response = await apiClient.patch(`${BASE_URL}/${id}`, settings);
  return response.data;
};

/**
 * Generate document preview PDF
 * @param {string} documentType - 'proforma' | 'invoice' | 'receipt'
 * @param {Object} config - Document configuration
 * @returns {Promise<Blob>} - PDF blob
 */
export const getDocumentPreview = async (documentType, config) => {
  const response = await apiClient.post(`${BASE_URL}/preview`, 
    { documentType, ...config },
    {
      responseType: 'blob',
      timeout: 60000, // 60 seconds for PDF generation
    }
  );
  return response.data;
};
